import { lazy } from 'react'

export const GreetingPage = lazy(() => import('./Greeting'))
export const StructurePage = lazy(() => import('./Structure'))
export const StructurePage2 = lazy(() => import('./Structure2'))
export const HistoryPage = lazy(() => import('./History'))
export const WorkPlanPage = lazy(() => import('./WorkPlan'))
export const WorkPlanAddPage = lazy(() => import('./WorkPlanAdd'))
export const WorkPlanEditPage = lazy(() => import('./WorkPlanEdit'))
export const ContactInfoPage = lazy(() => import('./ContactInfo'))
export const PartnerPage = lazy(() => import('./Partner'))
